<template>
  <div>
      <!--<li
        class="chat text-base pb-2"
        v-for="(item,key) in oplist"
        :key="key"
        style="list-style: none; font-size:1px;"
      >
        <B>{{item.uid}},{{item.name}},{{item.iine}}</B>
        <a></a>
      </li>-->
    <div
      style="list-style: none; border-radius: 3px; padding: initial; background-color:#FFFFFF; text-align:center; padding:20px;"
    >
      <h1>いいねスト賞</h1>

      <h3>NO.1</h3>

      <a class="item-image">
        <img :src="oplist[0].image" width="100" height="100" />
      </a>

      <h3>{{oplist[0].name}}</h3>
      <h3>{{oplist[0].iine}}いいね！</h3>

      <h3>NO.2</h3>

      <a class="item-image">
        <img :src="oplist[1].image" width="100" height="100" />
      </a>

      <h3>{{oplist[1].name}}</h3>
      <h3>{{oplist[1].iine}}いいね！</h3>

      <h3>NO.3</h3>

      <a class="item-image">
        <img :src="oplist[2].image" width="100" height="100" />
      </a>

      <h3>{{oplist[2].name}}</h3>
      <h3>{{oplist[2].iine}}いいね！</h3>
    </div>


  </div>
</template>


<script>
import firebase from "firebase/app";

export default {
  name: "finIinelist",
  props: ["selectedSession"],
  data() {
    return {
      image: "",
      oplist: []
    };
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.listen();
      } else {
      }
    });

    firebase
      .database()
      .ref("eventList/" + this.selectedSession + "/fromiineList/")
      .on("value", snapshot => {
        this.listen();
      });
  },
  watch: {
    selectedSession() {
      this.listen();
    }
  },
  methods: {
    listen() {
      // いいネストポイント獲得ランク
      var oplist = [];

      firebase
        .database()
        .ref("loginuser/")
        .on("value", snapshot => {
          if (snapshot.val()) {
            const uidlist = snapshot.val();
            Object.keys(uidlist).forEach((uid, key) => {
              var name = uidlist[uid].name;
              var image = uidlist[uid].image;

              var iine = 0;
              firebase
                .database()
                .ref(
                  "eventList/" +
                    this.selectedSession +
                    "/fromiineList/" +
                    uidlist[uid].uid
                )
                .on("value", snapshot => {
                  if (snapshot.val()) {
                    var rootList = snapshot.val();
                    const fromiineList1 = [];
                    Object.keys(rootList).forEach(function(val, key) {
                      if (rootList[val].iine) {
                        fromiineList1.push(rootList[val]);
                      }
                    });
                    iine = Object.keys(fromiineList1).length;
                  }
                });
              var iinelist = {
                name: name,
                image: image,
                iine: iine,
                uid:uid

              };
              oplist.push(iinelist);
            });
          }
          var toplist = oplist.sort(function(a, b) {
            if (a.iine > b.iine) return -1;
            if (a.iine < b.iine) return 1;
            return 0;
          });
          this.oplist = toplist
        });
    }
  }
};
</script>

<style>
.item-image img {
  border-radius: 50%;
  vertical-align: top;
}
</style>